/** Add-task callbacks for the task list actions hook. */
import { useCallback } from 'react';

export function useTaskListAddHandlers({
  user,
  addTask,
  selectNewTask,
  newTaskSessionRef,
  setNewlyAddedTask,
}) {
  const handleTaskAdded = useCallback(
    async (id, session) => selectNewTask && setNewlyAddedTask({ id, session }),
    [selectNewTask, setNewlyAddedTask],
  );

  const handleAddTask = useCallback(
    async (data, pos) => {
      if (!user) return null;
      const sessionAtStart = newTaskSessionRef?.current;
      const id = await addTask(data, pos);
      if (id) handleTaskAdded(id, sessionAtStart);
      return id;
    },
    [user, addTask, handleTaskAdded, newTaskSessionRef],
  );

  return { handleAddTask, handleTaskAdded };
}
